import { useState, useEffect, useRef } from "react";
import { useRadixConnect } from "../../../radix_connect";
import "./CustomSelectRadixAccount.scss";

const CustomSelectRadixAccount = () => {
  const { rdt, connected, selectedAccount, setSelectedAccount, accounts } =
    useRadixConnect();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setDropdownOpen(!dropdownOpen);
  };

  const handleSelectAccount = (account) => {
    setSelectedAccount(account);
    setDropdownOpen(false);
  };

  const renderAccountLabel = (account) => {
    const shortAddress = `${account.address.slice(0, 6)}...${account.address.slice(-4)}`;
    return account.label ? `${account.label} (${shortAddress})` : shortAddress;
  };


  if (!connected || !rdt) {
    return null;
  }

  return (
    <div className="custom-select active" ref={dropdownRef}>
      <button
        className="select-button"
        role="combobox"
        aria-label="Select an Account"
        aria-haspopup="listbox"
        aria-expanded={dropdownOpen}
        onClick={toggleDropdown}
        aria-controls="select-dropdown"
      >
        <span className="selected-value">
          {selectedAccount
            ? renderAccountLabel(selectedAccount)
            : "Select Account"}
        </span>
        <span className="arrow" />
      </button>
      {dropdownOpen && accounts.length > 0 && (
        <ul className="select-dropdown" role="listbox" id="select-dropdown">
          {accounts.map((account) => (
            <li
              key={account.address}
              role="option"
              className={`account-appearance-${account.appearanceId}`}
              onClick={() => handleSelectAccount(account)}
            >
              <input
                type="radio"
                name="radix-account"
                value={account.address}
                checked={selectedAccount && selectedAccount.address === account.address}
                onChange={() => handleSelectAccount(account)}
              />
              <label>
                {renderAccountLabel(account)}
              </label>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomSelectRadixAccount;
